// extracted by mini-css-extract-plugin
export default {"content":"Edit_content__zsLMr"};